import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function CountdownBanner() {
  const [config, setConfig] = useState(null);
  useEffect(() => { api.get("/config").then(({ data }) => setConfig(data)); }, []);
  if (!config || config.today >= config.campaign_start) return null;
  const days = Math.ceil((new Date(config.campaign_start + "T00:00:00") - new Date(config.today + "T00:00:00")) / 86400000);
  return (
    <div className="sw-red text-white text-sm font-medium text-center py-2 px-4" data-testid="countdown-banner">
      Site Wars begins in {days} day{days === 1 ? "" : "s"} — <Link to="/how-it-works" className="underline font-semibold hover:text-white/80" data-testid="countdown-banner-link">see how it works</Link>
    </div>
  );
}
